let value = {
  version:
    `${process.env.REACT_APP_VERSION}/${process.env.REACT_APP_ENV[0]}`.toUpperCase(),
}

export default function useDataTransform(props, data) {
  return value
}
